import React, { useEffect, useState } from 'react'
import { UiComponents } from "@simulanisindia/ui";
import { TreeSelect } from "primereact/treeselect";
import SimRadioButton from '../RadioButton';
import { PAID_PACK, SIMULANIS_INDIA, SIMULANIS_UK, TRIAL_PACK } from '../../Constant/constant';
import { useDispatch, useSelector } from 'react-redux';
import { setAmount, setEntityType, setInvoice, setPlanType, setSaleType, setUseCaseTgs } from '../../Store/slice/subscriptionSlice';
import apiClient from '../../apiClient';
import { categoryIds, SSO_URL } from '../../env';
import { CATEGORY_ALL_SUBCATEGORY, CATEGORY_TAGS_LIST } from '../../apiClient/apiEndpoints';

const { SimInputBar, DropdownSearch } = UiComponents;

const EnterInvoice = () => {
    const dispatch = useDispatch();
    const [saleTypesList, setSaleTypesList] = useState([]);
    const [useCaseTags, setUseCaseTags] = useState([]);
    const [useCaseList, setUseCaseList] = useState(null);
    const [selectedUseCase, setSelectedUseCase] = useState(null);

    const { amount, invoice, planType, entityType, saleType, useCaseTgs, checkedApplication } = useSelector(state => state.subscriptionSlice);

    useEffect(()=>{
        let totalAmount = checkedApplication.reduce((sum,item) =>{
                         return sum + parseFloat(item.amount || 0) 
        },0);
         dispatch(setAmount({ data: totalAmount }));
    },[checkedApplication])

    const handleSetAmount = (value) => {
        if (value === '' || /^[0-9]*$/.test(value)) {
            dispatch(setAmount({ data: value }));
        }
    };
    const handleSelectSaleType = (value) => {
        dispatch(setSaleType({ data: value }));
    };

    const handleSelectUseCase = (value) => {
        dispatch(setUseCaseTgs({ data: value }));
    };

    const getSaleTypes = async () => {
        try {
            let data = await apiClient.get(`${SSO_URL}${CATEGORY_TAGS_LIST}/${categoryIds["SALE_TYPES"]}`)
            let tagsList = data.map(e => ({ label: e.name, value: e.id }));
            setSaleTypesList(tagsList);
        } catch (error) {
            console.log(error);
        }
    };

    const getAllUseCaseCategory = async () => {
        try {
            let data = await apiClient.get(`${SSO_URL}${CATEGORY_ALL_SUBCATEGORY}/${categoryIds["USE_CASE"]}`);          
            setUseCaseList(data.children.map(e => ({label: e.name, value: e.id, tags:e.tags})));
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getSaleTypes();
        getAllUseCaseCategory();
    }, []);

    useEffect(()=>{
      if(selectedUseCase){
         let tagsList = useCaseList?.find(e => e?.value === selectedUseCase?.value)?.tags || [];
         let tags = tagsList.map(e => ({label: e.name, value: e.id}))
         setUseCaseTags(tags);
        }
    },[selectedUseCase]);

    return (
        <>
            <div className="colorborder" style={{ height: 'auto' }}>
                <div className="enterinvoice-page">
                    <h5>Enter Invoice</h5>
                    <p>Enter the Simulanis Invoice ID to attach the bill details</p>
                    <div className="row mt-3">
                        <div className="col-md-5">
                            <div className="form-group mb-3">
                                <label>Enter Amount</label>
                                <SimInputBar placeholder="Enter Amount" value={amount} onChange={(e) => handleSetAmount(e.target.value)} />
                            </div>
                            <div className="form-group mb-3">
                                <label>Simulanis Invoice ID</label>
                                <SimInputBar placeholder="Enter Simulanis Invoice ID" value={invoice} onChange={(e) => dispatch(setInvoice({ data: e.target.value }))} />
                            </div>
                        </div>
                    </div>


                    <div className="plantype mt-2">
                        <div className='org-validity'>
                            <div className='validity-time mt-1'>
                                <DropdownSearch
                                    label="Sale Type*"
                                    selectProps={{
                                        options: saleTypesList,
                                        value: saleType,
                                        onChange: (e) => handleSelectSaleType(e),
                                    }}
                                />
                            </div>
                        </div>
                    </div>


                    <div className="plantype mt-2">
                        <div className='org-validity'>
                            <div className='validity-time mt-1'>
                                <DropdownSearch
                                    label="use case*"
                                    selectProps={{
                                        options: useCaseList,
                                        value: selectedUseCase,
                                        onChange: (e) => setSelectedUseCase(e),
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="plantype mt-2">
                        <div className='org-validity'>
                            <div className='validity-time mt-1'>
                                <DropdownSearch
                                    label="select tags*"
                                    selectProps={{
                                        options: useCaseTags,
                                        value: useCaseTgs,
                                        isMulti: true,
                                        onChange: (e) => handleSelectUseCase(e),
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="plantype mt-2">
                        <div className='org-validity'>
                            <p>Entity Type*</p>
                            <div className='validity-time mt-3'>
                                <SimRadioButton label="India" id='entityIndia' onChange={() => dispatch(setEntityType({ data: SIMULANIS_INDIA }))} checked={entityType === SIMULANIS_INDIA} name="entity_type" />
                                <SimRadioButton label="Uk" id='entityUk' onChange={() => dispatch(setEntityType({ data: SIMULANIS_UK }))} checked={entityType === SIMULANIS_UK} name="entity_type" />
                            </div>
                        </div>
                    </div>

                    <div className="plantype mt-2">
                        <div className='org-validity'>
                            <p>Plan Type*</p>
                            <div className='validity-time mt-3'>
                                <SimRadioButton label="Trial Plan" id='trialplan' onChange={() => dispatch(setPlanType({ data: TRIAL_PACK }))} checked={planType === TRIAL_PACK} name="plan_type" />
                                <SimRadioButton label="Paid Plan" id='paid' onChange={() => dispatch(setPlanType({ data: PAID_PACK }))} checked={planType === PAID_PACK} name="plan_type" />
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </>
    )
}

export default EnterInvoice
